import { render } from "./InfoList.vue?vue&type=template&id=4c525099&scoped=true"
import script from "./InfoList.vue?vue&type=script&lang=js"
export * from "./InfoList.vue?vue&type=script&lang=js"

import "./InfoList.vue?vue&type=style&index=0&id=4c525099&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c525099"]])

export default __exports__